import { Button, Card } from "@breakingthelines/design-system";
import { useNavigate } from "react-router-dom";

export function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <Card style={{ maxWidth: 420, margin: "80px auto", textAlign: "center" }}>
      {/* Explicit type: Tailwind's preflight zeroes heading size, weight and
          margin, and these two pages have no stylesheet of their own. */}
      <h3 style={{ fontSize: 20, fontWeight: 600, margin: "0 0 12px" }}>404 · Not Found</h3>
      <p style={{ margin: "0 0 20px" }}>The page you were looking for does not exist.</p>
      <Button onClick={() => navigate("/")}>Return home</Button>
    </Card>
  );
}
